import ChangePassword from './ChangePassword.component';
export default ChangePassword;
